import Notice from '@components/LocalMerchant/Notice'

export default {
  path: 'notice',
  component: Notice,
  indexRoute: {
    component: Notice
  },
  stat: '店铺公告/首页'
}
